package one.healthium.domain.paywall.models

import kotlinx.serialization.Contextual
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames
import one.healthium.domain.common.Color
import one.healthium.domain.common.ReviewItem
import one.healthium.domain.common.TextStyle

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("reviews_v3")
data class PaywallReviewsView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PaywallReviewsConfig,
) : PaywallScreenView

@Serializable
data class PaywallReviewsConfig(
    @SerialName("bg_color") @Contextual val bgColor: Color? = null,
    @SerialName("review_label") val reviewTextStyle: TextStyle,
    @SerialName("author_label") val authorTextStyle: TextStyle,
    @SerialName("items") val items: List<ReviewItem> = emptyList(),
)
